/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  SUBMIT_CSV_FILE_SA_REGISTRATION_STATUS,
  UPLOAD_CSV_FILE_SA_REGISTRATION_STATUS,
  SUBMIT_CSV_FILE_SA_PROGRAM_STATUS,
  UPLOAD_CSV_FILE_SA_PROGRAM_STATUS,
} from "Constants/SagaConstants";
import { IApiResult2 } from "Interfaces/IApiResult";
import { ISubmitCSVFileRequest, IUploadCSVFileRequest } from "Interfaces/SA/IUploadCSVFileRequest";
import { IHttpResponse, post } from "Services/ApiUtils";

/**
 * Uploads the csv file.
 * @param fileString CsvBase64 file as string.
 */
export async function uploadCSVFile(
  fileString: IUploadCSVFileRequest
): Promise<IHttpResponse<IApiResult2<string>>> {
  return await post<IApiResult2<string>>(UPLOAD_CSV_FILE_SA_REGISTRATION_STATUS, fileString, true);
}

/**
 * Submits the csv file.
 * @param fileId it is expected to hold a textual identifier (likely representing the ID of a CSV file).
 */
export async function submitCSVFile(
  fileId: ISubmitCSVFileRequest
): Promise<IHttpResponse<IApiResult2<string>>> {
  return await post<IApiResult2<string>>(SUBMIT_CSV_FILE_SA_REGISTRATION_STATUS, fileId, true);
}

/**
 * Uploads the csv file for Program Status update
 * @param fileString CsvBase64 file as string.
 */
export async function uploadProgramStatusCSVFile(
  fileString: IUploadCSVFileRequest
): Promise<IHttpResponse<IApiResult2<string>>> {
  return await post<IApiResult2<string>>(UPLOAD_CSV_FILE_SA_PROGRAM_STATUS, fileString, true);
}

/**
 * Submits the csv file Program Status update.
 * @param fileId it is expected to hold a textual identifier (likely representing the ID of a CSV file).
 */
export async function submitProgramStatusCSVFile(
  fileId: ISubmitCSVFileRequest
): Promise<IHttpResponse<IApiResult2<string>>> {
  return await post<IApiResult2<string>>(SUBMIT_CSV_FILE_SA_PROGRAM_STATUS, fileId, true);
}
